import { QueryParams } from "../type";

export const VESSEL_KEYS = {
  VESSEL: "VESSEL",
  GET_VESSELS: (params?: QueryParams) => [`${VESSEL_KEYS.VESSEL}/list`, params],
  GET_VESSELS_DROPDOWN: () => [`${VESSEL_KEYS.VESSEL}/dropdown`],
  GET_VESSEL_BY_ID: (id: string) => [`${VESSEL_KEYS.VESSEL}/detail`, id],
  GET_VESSEL_ASSIGNMENTS: () => [`${VESSEL_KEYS.VESSEL}/assignments`],
  GET_TODAY_VESSEL_ASSIGNMENTS: () => [`${VESSEL_KEYS.VESSEL}/today-assignments`],
  GET_VESSEL_LOAD_LISTS: (params?: QueryParams) => [`${VESSEL_KEYS.VESSEL}/load-lists`, params],
  GET_VESSEL_LOAD_LIST: (vesselId: string, params?: QueryParams) => [`${VESSEL_KEYS.VESSEL}/${vesselId}/load-list`, params],
  GET_VESSEL_TYPES: (params?: QueryParams) => [
    VESSEL_KEYS.VESSEL,
    "types",
    params,
  ],
  CREATE_VESSEL: () => [VESSEL_KEYS.VESSEL, "create"],
  UPDATE_VESSEL: () => [VESSEL_KEYS.VESSEL, "update"],
  DELETE_VESSEL: () => [VESSEL_KEYS.VESSEL, "delete"],
  CREATE_VESSEL_TYPE: () => [VESSEL_KEYS.VESSEL, "types", "create"],
  UPDATE_VESSEL_TYPE: () => [VESSEL_KEYS.VESSEL, "types", "update"],
  DELETE_VESSEL_TYPE: () => [VESSEL_KEYS.VESSEL, "types", "delete"],

  SHUTTLE: "SHUTTLE",
  GET_SHUTTLES: (params?: QueryParams) => [VESSEL_KEYS.SHUTTLE, "list", params],
  CREATE_SHUTTLE: () => [VESSEL_KEYS.SHUTTLE, "create"],
  UPDATE_SHUTTLE: () => [VESSEL_KEYS.SHUTTLE, "update"],
  DELETE_SHUTTLE: () => [VESSEL_KEYS.SHUTTLE, "delete"],
  GET_SHUTTLE_BY_ID: (id: string) => [VESSEL_KEYS.SHUTTLE, id],
};
